/* GENERATED by tools/dc-port */
import { DashboardView } from './Dashboard.view';
import { WidgetsView } from './Widgets.view';
import { BriefingView } from './Briefing.view';
import { PrepareView } from './Prepare.view';
import { RiskRulesView } from './RiskRules.view';
import { RiskProfileView } from './RiskProfile.view';
import { StrategiesView } from './Strategies.view';
import { TradeHubView } from './TradeHub.view';
import { SignalsView } from './Signals.view';
import { TradesView } from './Trades.view';
import { CopyTradingView } from './CopyTrading.view';
import { AnalyticsView } from './Analytics.view';
import { AiInsightsView } from './AiInsights.view';
import { PfScoreView } from './PfScore.view';
import { JournalView } from './Journal.view';
import { ReplayView } from './Replay.view';
import { AcctProgressView } from './AcctProgress.view';
import { EodView } from './Eod.view';
import { AccountsView } from './Accounts.view';
import { NotificationsView } from './Notifications.view';
import { SettingsView } from './Settings.view';
import { CompareView } from './Compare.view';
import { DigestView } from './Digest.view';
import { TradingIdentityView } from './TradingIdentity.view';
import { StubView } from './Stub.view';
import { TradingIntelView } from '../composed/TradingIntel.view';
import { InvestorsView } from '@/screens/composed/Investors.view';
import { BillingView } from '../composed/Billing.view';

export const SCREENS = {
  Dashboard: DashboardView,
  Widgets: WidgetsView,
  Briefing: BriefingView,
  Prepare: PrepareView,
  RiskRules: RiskRulesView,
  RiskProfile: RiskProfileView,
  Strategies: StrategiesView,
  TradeHub: TradeHubView,
  Signals: SignalsView,
  Trades: TradesView,
  CopyTrading: CopyTradingView,
  Analytics: AnalyticsView,
  AiInsights: AiInsightsView,
  PfScore: PfScoreView,
  Journal: JournalView,
  Replay: ReplayView,
  AcctProgress: AcctProgressView,
  Eod: EodView,
  Accounts: AccountsView,
  Notifications: NotificationsView,
  Settings: SettingsView,
  Compare: CompareView,
  Digest: DigestView,
  TradingIdentity: TradingIdentityView,
  Stub: StubView,
  TradingIntel: TradingIntelView,
  Investors: InvestorsView,
  Billing: BillingView,
} as const;
